import { createOpenIdConnectContext } from '@bos/openid-connect';

import { tokenStorage } from '../../auth/tokenStore/tokenStore';
import { env } from '../../env';
import { useUserScopesFromUmaPermissions } from '../hooks/useUserScopesFromUmaPermissions';

export const PID_AUTH_CALLBACK_PATH = '/auth/pid-callback';

const UNEXPECTED_RUNTIME_ERROR_TEXT =
	'Unexpected runtime error: OpenIdConnectContext not initialized';

const throwError = () => {
	throw new Error(UNEXPECTED_RUNTIME_ERROR_TEXT);
};

const redirectCallbackUrl = new URL(
	PID_AUTH_CALLBACK_PATH,
	window.location.href,
);

const openIdContext = createOpenIdConnectContext({
	tokenStorage,
	client: {
		issuerUrl: new URL(env.CLIENT_ISSUER_URL),
		clientId: env.CLIENT_CLIENT_ID,
	},
	redirectCallbackUrl,
});
export const TokenProvider = openIdContext?.OpenIdConnectProvider ?? throwError;
export const useTokenCallbackHandler =
	openIdContext?.useOpenIdConnectCallbackHandler ?? throwError;
export const useTokenContext =
	openIdContext?.useOpenIdConnectContext ?? throwError;

export const useRedirectToLoginPage = () => {
	const tokenContext = openIdContext?.useOpenIdConnectContext();

	return () => {
		if (!tokenContext) return;

		const kcHintValue = env.CLIENT_PID_KEYCLOAK_IDP_HINT;

		const extraParameters: Record<string, string> = kcHintValue
			? {
					kc_idp_hint: kcHintValue,
				}
			: {};

		tokenContext.redirectToLoginPage({ extraParameters });
	};
};

export const useUserScopes = () => {
	const { accessToken } = useTokenContext();

	return useUserScopesFromUmaPermissions({
		issuerUrl: new URL(env.CLIENT_ISSUER_URL),
		accessToken,
		audience: env.CLIENT_RESOURCE_SERVER,
	});
};
